import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {GRAY_DARKER} from 'ui-library/Colors';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

import {MergeTransform} from '../../RunSchemaSpecConstants';
import {
  CSVTextAreaInput,
  getColumnNamesFromInput,
  MergeFormErrors,
  updateTransformationProperties,
} from './TransformFormUtils';

interface MergeFormProps {
  transform: MergeTransform;
  onChange: (transform: MergeTransform) => void;
  formErrors: MergeFormErrors;
}
// TODO handle setting delimiter to "" by default
export default function MergeForm(props: MergeFormProps): JSX.Element {
  return (
    <>
      <Row className={css(styles.columnNamesContainer)}>
        <Col md={12}>
          <FieldLabel label="Columns to merge" labelStyle={LabelStyle.LABEL} isRequired={true} />
          <CSVTextAreaInput
            value={props.transform.transformationProperties.columnNames}
            placeholder="Volume, Concentration"
            onChange={(value) => {
              props.onChange(updateTransformationProperties(props.transform, 'columnNames', value));
            }}
            parseCSVInputFn={getColumnNamesFromInput}
            hasError={props.formErrors.columnNames}
          />
          {props.formErrors.columnNames ? (
            <ErrorMessage error="At least 2 column names are required" />
          ) : null}
          <div className={css(styles.description)}>
            Enter a list of columns, separated by comma. New column will appear at the same position as the
            first merged column.
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <TextField
            label="Delimiter"
            onChange={(e) => {
              props.onChange(updateTransformationProperties(props.transform, 'delimiter', e.target.value));
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            value={props.transform.transformationProperties.delimiter}
          />
          <div className={css(styles.description)}>Leave blank to merge without separating character.</div>
        </Col>
        <Col md={4}>
          <TextField
            label="New column name"
            onChange={(e) => {
              props.onChange(
                updateTransformationProperties(props.transform, 'outputColumnName', e.target.value)
              );
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            isRequired={true}
            value={props.transform.transformationProperties.outputColumnName}
            hasError={props.formErrors.outputColumnName}
          />
          {props.formErrors.outputColumnName ? <ErrorMessage error="Column name is required" /> : null}
        </Col>
      </Row>
    </>
  );
}

const styles = StyleSheet.create({
  description: {
    fontSize: 13,
    lineHeight: '16px',
    color: GRAY_DARKER,
    paddingTop: '7px',
  },
  columnNamesContainer: {
    paddingBottom: '25px',
  },
});
